import React, { useState } from 'react';
// import { WaveBackground } from './wave-background';
import { ImageSlider } from './ImageSlider';
import './App.css';
import paanai from './assets/paanai.jpeg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import nutritionfacts from './assets/nutritionfacts.png';
const App = () => {
const [language, setLanguage] = useState('en');
const [scale, setScale] = useState(1); // State for image scaling
const content = {
en: {
title: 'Welcome to Mud Pot Health – Embrace the Goodness of Nature',
intro: 'Your Gateway to Traditional Natural Foods',
about: `At Mud Pot Health, we take immense pride in offering the very best of natural, organic, and heritage foods directly to your doorstep. We combine centuries-old traditions with modern convenience to deliver wholesome, nutritious products that nurture your well-being.`,
offerings: [
{
name: 'Pure Malli Rice',
description: `Prepared using sustainable farming practices, Malli Rice is known for its rich texture and subtle aroma. Its benefits include: Supporting digestive health, maintaining blood sugar levels, and offering a soothing experience in traditional recipes.`,
},
{
name: 'Karuppu Kavuni Rice',
description: `Known as the "Forbidden Rice," Karuppu Kavuni is high in protein and antioxidants, reduces inflammation, and promotes cardiovascular health.`,
},
],
contact: 'Need help? Reach us at: +91 98401 72286 / 98418 75909',
},
ta: {
title: 'மட் பாட்டு ஹெல்த் – இயற்கையின் நலன் கொண்ட உணவுகளுக்கு உங்களை வரவேற்கிறது',
intro: 'மரபு உணவுகளின் நம்பகமான வலி',
about: `மட் பாட்டு ஹெல்த்-ல், சிறந்த இயற்கை, ஆர்கானிக் மற்றும் மரபு உணவுப் பொருட்களை உங்கள் வீட்டுக்கே நேரடியாக வழங்குவதில் பெருமை கொள்கிறோம். பல்லாண்டுகளாக நிலைத்திருக்கும் தமிழ் கலாச்சார உணவுப் பாரம்பரியத்தையும், நவீன உலகத்தின் வசதிகளையும் இணைத்துக் கொண்டு நன்மை தரக்கூடிய, ஆரோக்கியமான உணவுகளை உங்களுக்கு வழங்குகிறோம்.`,
offerings: [
{
name: 'தூய மல்லி அரிசி',
description: `இயற்கை முறையில் தயாரிக்கப்படும் மல்லி அரிசி அதன் எளிமையான நறுமையுடனும் ஆரோக்கிய சிறப்புகளுடனும் பெரிதும் போற்றப்படுகிறது. இது ஜீரணத்தை நலம் பெறச் செய்கிறது மற்றும் இரத்தச்சர்க்கரை நிலைமை கட்டுப்படுத்த உதவும்.`,
},
{
name: 'கருப்புக் கவுணி அரிசி',
description: `"மர்மமான அரிசி" என்று அழைக்கப்படும் கருப்புக் கவுணி புரதம் மற்றும் ஆன்டிஆக்சிடென்ட்களை அதிகமாக கொண்டுள்ளது மற்றும் உடலுக்கு பல நன்மைகளை வழங்குகிறது.`,
},
],
contact: 'உதவி தேவை? எங்களை தொடர்புகொள்ளவும்: +91 98401 72286 / 98418 75909',
},
};

const handleZoomIn = () => {
setScale((prev) => prev + 0.1); // Increase scale by 0.1
};

const handleZoomOut = () => {
setScale((prev) => (prev > 0.1 ? prev - 0.1 : 0.1)); // Decrease scale by 0.1, but not below 0.1
};

const resetZoom = () => {
setScale(1); // Reset scale to the default
};
 // Inline styles
 const buttonStyle = (isActive) => ({
  backgroundColor: isActive ? "#D4AF37" : "transparent", // Yellow for active, transparent for inactive
  color: isActive ? "#004D40" : "#D4AF37", // Dark text for active, yellow text for inactive
  border: "2px solid #D4AF37", // Yellow border for all buttons
  padding: "10px 20px",
  borderRadius: "5px",
  cursor: "pointer",
  marginRight: "10px",
  transition: "all 0.3s ease-in-out",
});
return (
<div className="wave-bg min-h-screen">
{/* <WaveBackground /> */}
<nav className="navbar navbar-expand-lg fixed-top">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center w-100">
          <span className="navbar-brand d-flex align-items-center">
            <img
              src={paanai}
              alt="Mud Pot Logo"
              className="me-2"
              style={{ height: "40px", width: "auto" }}
            />
            <div>
              <div className="fs-4 fw-bold">MUD POT</div>
              <div className="fs-6">HEALTH MIX</div>
            </div>
          </span>
          <div className='d-flex align-items-center'>
            <button
              style={buttonStyle(language === "en")}
              onClick={() => setLanguage("en")}
              className="me-1"
            >
              English
            </button>
            <button
              style={buttonStyle(language === "ta")}
              onClick={() => setLanguage("ta")}
            >
              தமிழ்
            </button>
          </div>
        </div>
      </div>
    </nav>
<header className="text-center py-5 mt-5 position-relative">
<div className="container pt-5">
<h1 className="display-4 fw-bold text-white mb-4">{content[language].title}</h1>
<p className="lead text-white-50">{content[language].intro}
<a href="#" data-bs-toggle="modal" data-bs-target="#imageModal" style={{color:'white', fontWeight:'600',marginLeft:'10px', fontSize:'19px' }}>
<FontAwesomeIcon
icon={faBook}
style={{ color: "yellow", width: "20px", height: "20px" }}
/>Nutrition Facts
</a>
</p>



{/* Modal */}
<div
className="modal fade"
id="imageModal"
tabIndex="-1"
aria-labelledby="imageModalLabel"
aria-hidden="true"
>
<div className="modal-dialog modal-lg">
<div className="modal-content">
<div className="modal-header">
<h5 className="modal-title" id="imageModalLabel">
Nutrition Facts
</h5>
<button
type="button"
className="btn-close"
data-bs-dismiss="modal"
aria-label="Close"
></button>
</div>
<div
className="modal-body"
style={{
overflow: "auto", // Enables scrolling
maxHeight: "80vh", // Limits height for better usability
}}
>
{/* Image Container */}
<div
style={{
display: "flex",
justifyContent: "center",
alignItems: "center",
minHeight: "50vh", // Ensures image is centered initially
}}
>
{/* Image with zoom */}
<img
src={nutritionfacts}
alt="Nutrition Facts"
style={{
transform: `scale(${scale})`,
transformOrigin: "center", // Keeps zoom centered
transition: "transform 0.3s ease-in-out",
}}
/>
</div>
</div>
<div className="modal-footer">
{/* Zoom Controls */}
<button className="btn btn-secondary" onClick={handleZoomIn}>
Zoom In
</button>
<button className="btn btn-secondary" onClick={handleZoomOut}>
Zoom Out
</button>
<button className="btn btn-secondary" onClick={resetZoom}>
Reset
</button>
<button
type="button"
className="btn btn-danger"
data-bs-dismiss="modal"
>
Close
</button>
</div>
</div>
</div>
</div>

</div>
</header>

{/* Image Marquee Section */}
<div className="py-5">
<ImageSlider />
</div>


<main className="container py-5">
<section className="mb-5">
<h2 className="section-title mb-4">
{language === 'en' ? 'About Us' : 'எங்களைப் பற்றி'}
</h2>
<div className="card">
<div className="card-body">
<p className="mb-0">{content[language].about}</p>
</div>
</div>
</section>

<section className="mb-5">
<h2 className="section-title mb-4">
{language === 'en' ? 'Our Offerings' : 'எங்கள் தயாரிப்புகள்'}
</h2>
<div className="row g-4">
{content[language].offerings.map((item, index) => (
<div className="col-md-6" key={index}>
<div className="card h-100">
<div className="card-body">
<h5 className="card-title fw-bold mb-3" style={{ color: 'var(--primary)' }}>
{item.name}
</h5>
<p className="card-text">{item.description}</p>
</div>
</div>
</div>
))}
</div>
</section>

<footer className="text-center mt-5">
<div className="card">
<div className="card-body">
<p className="mb-0">{content[language].contact}</p>
</div>
</div>
</footer>
</main>
</div>
);
};

export default App;

